import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK BOXEO LISTO',
  description: '6 tomos + 6 bonos',
  originalPrice: '$34.990',
  price: '$19.990',
  ctaText: '→ QUIERO MI MEGAPACK BOXEO LISTO',
  ctaHref: 'https://www.profepack.com/cart/48567263133952:1'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + MÉTODO GYM LLENO',
  description: '6 tomos + 6 bonos + Método Gym Lleno™ (Precios élite, sistema de membresías, captación, retención y marketing local)',
  originalPrice: '$43.990',
  price: '$27.990',
  ctaText: '→ SÍ, QUIERO EL MEGAPACK + MÉTODO GYM LLENO',
  ctaHref: 'https://www.profepack.com/cart/48567263166720:1',
  isFeatured: true,
  savings: 'AHORRÁS $16.000'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-294">
      <div className="max-w-xl mx-auto" data-id="element-295">
        {/* Header */}
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-296">
          🛒 ELEGÍ TU{' '}
          <span className="text-[#F97316]" data-id="element-297">MEGAPACK BOXEO LISTO:</span>
        </h2>
        <p className="text-gray-300 text-center text-xs sm:text-base mb-5 sm:mb-10" data-id="element-298">
          Las dos opciones incluyen los 6 bonos estratégicos completos
        </p>

        {/* Options */}
        <div className="space-y-3 sm:space-y-4 mb-5 sm:mb-8" data-id="element-299">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-4 sm:p-6 transition-all ${isFeatured && isSelected ? 'border-2 border-[#F97316] bg-[#0d0700] shadow-[0_0_30px_rgba(249,115,22,0.15)]' : isFeatured ? 'border-2 border-[#F97316]/50 bg-[#0d0700]' : isSelected ? 'border-2 border-[#F97316] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-300">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-301">
                  {/* Radio */}
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#F97316]' : 'border-white/30'}`} data-id="element-302">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#F97316]" data-id="element-303" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-304">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-305">
                      <span className="text-lg" data-id="element-306">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-307">
                        {option.title}
                      </span>
                    </div>

                    {/* Badges */}
                    {isFeatured && <div className="flex items-center gap-2 mt-1.5 sm:mt-2 flex-wrap" data-id="element-308">
                        <span className="bg-[#F97316] text-black text-[11px] sm:text-xs font-black px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full" data-id="element-309">
                          ⭐ MÁS ELEGIDA
                        </span>
                        {option.savings && <span className="bg-[#F97316]/20 text-[#F97316] text-[11px] sm:text-xs font-bold px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full border border-[#F97316]/40" data-id="element-310">
                            {option.savings}
                          </span>}
                      </div>}

                    <p className="text-gray-400 text-sm mt-1" data-id="element-311">
                      {option.description}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-312">
                    <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-313">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#F97316]' : 'text-white'}`} data-id="element-314">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-green-pulse block w-full text-center bg-[#F97316] font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-[#FB923C] transition-colors text-[#FFFFFF]" data-id="element-315">
          {selectedOption.ctaText}
        </a>

        {/* Subtitle under CTA */}
        <p className="text-gray-400 text-xs sm:text-sm text-center mt-3 sm:mt-4 italic" data-id="element-316">
          {selected === 'elite' ? 'La más elegida por entrenadores que quieren profesionalizarse y cobrar lo que realmente merecen' : 'El sistema completo de clases para entrenadores de boxeo'}
        </p>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-300 mt-6 sm:mt-8 bg-[#0a0a0a] border border-[#F97316]/20 rounded-xl py-3 sm:py-4 px-4 sm:px-6" data-id="element-317">
          <span data-id="element-318">🔒 Pago seguro</span>
          <span data-id="element-319">⚡ Acceso en 5 min</span>
          <span data-id="element-320">🛡️ Garantía 7 días</span>
          <span data-id="element-321">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}